module.exports = __webpack_public_path__ + "img/instructor.f10c78b7.png";